import { configureStore } from "@reduxjs/toolkit";

import { equipmentsApi } from "./equipmentsApi";
import { trainingsApi } from "./trainingsApi";
import { usersApi } from "./usersApi";
import { paymentsApi } from "./paymentApi";
import { quizApi } from "./quizApi";
import { videoAnalysisApi } from "./videoAnalysisApi";
import { authApi } from "@/features/auth/model/authApi";
import authReducer from "@/features/auth/model/authSlice";

export const store = configureStore({
  reducer: {
    auth: authReducer,
    [authApi.reducerPath]: authApi.reducer,
    [trainingsApi.reducerPath]: trainingsApi.reducer,
    [equipmentsApi.reducerPath]: equipmentsApi.reducer,
    [usersApi.reducerPath]: usersApi.reducer,
    [paymentsApi.reducerPath]: paymentsApi.reducer,
    [quizApi.reducerPath]: quizApi.reducer,
    [videoAnalysisApi.reducerPath]: videoAnalysisApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware()
      .concat(authApi.middleware)
      .concat(trainingsApi.middleware)
      .concat(equipmentsApi.middleware)
      .concat(usersApi.middleware)
      .concat(paymentsApi.middleware)
      .concat(quizApi.middleware)
      .concat(videoAnalysisApi.middleware),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;